import axios from 'axios'

function showAlertForStatusCode(statusCode) {
  const statusMessages = {
    201: "201 - Resource created successfully.",
    202: "202 - Request accepted but processing not completed.",
    204: "204 - Request successful but no content to return.",
    301: "301 - Resource moved permanently to a new URL.",
    302: "302 - Resource temporarily located at a different URL.",
    304: "304 - Resource not modified since the last request.",
    400: "400 - Bad request - the server could not understand the request.",
    401: "401 - Unauthorized - authentication is required.",
    403: "403 - Forbidden - access is denied.",
    404: "404 - Not found - the resource cannot be found.",
    405: "405 - Method not allowed for this resource.",
    500: "500 - Internal server error - something went wrong on the server.",
    501: "501 - Not implemented - the server does not support this functionality.",
    503: "503 - Service unavailable - the server is temporarily unable to handle the request."
  };

  if (statusCode !== 200 && statusMessages[statusCode]) {
    alert(statusMessages[statusCode]);
  }
}

export function axiosGetPost(
  method,
  url,
  dataBody = {},
) {
  var currentDate = new Date()
  if (method.toUpperCase() === 'GET') {
    return axios
      .get(url)
      .then((response) => {
        const data = response.data
        return data
      })
      .catch((error) => {
        showAlertForStatusCode(error.response.status)
        return null
      })
  } else if (method.toUpperCase() === 'POST') {
    return axios
      .post(url, dataBody)
      .then((response) => {
        const data = response.data
        return data
      })
      .catch((error) => {
        showAlertForStatusCode(error.response.status)
        return null
      })
  } else if (method.toUpperCase() === 'PUT') {
    return axios
      .put(url, dataBody)
      .then((response) => {
        const data = response.data
        return data
      })
      .catch((error) => {
        showAlertForStatusCode(error.response.status)
        return null
      })
  } else if (method.toUpperCase() === 'GET-NO-DATA') {
    return axios
      .get(url)
      .then((response) => {
        const data = response
        return data
      })
      .catch((error) => {
        showAlertForStatusCode(error.response.status)
        return null
      })
  } else if (method.toUpperCase() === 'POST-NO-DATA') {
    return axios
      .post(url, dataBody)
      .then((response) => {
        const data = response
        return data
      })
      .catch((error) => {
        showAlertForStatusCode(error.response.status)
        return null
      })
  } else if (method.toUpperCase() === 'PUT-NO-DATA') {
    return axios
      .put(url, dataBody)
      .then((response) => {
        const data = response
        return data
      })
      .catch((error) => {
        showAlertForStatusCode(error.response.status)
        return null
      })
  }
}
